import randomColor from "randomcolor";
import { renderPopupContainer } from "../popups/renderPopupContainer";

/**
 * Crea un L.geoJSON con:
 * - style default (seed por id)
 * - pointRenderer (opcional)
 * - popup (string | ReactElement | fn(feature, item, api))
 *
 * Retorna:
 * - layer: L.GeoJSON
 * - popupToOpen: layer interno al que se le bindPopup (si existió)
 */
export function createGeoJSONLayer(
    L,
    {
        geojson,
        layerId,
        item,
        style,
        pane,
        pointRenderer,
        popupContent,
        autoOpenPopup = false,
    },
) {
    try {
        let popupToOpen = null;

        const layer = L.geoJSON(geojson, {
            pane,

            style: style ||
                item?.style || {
                color: randomColor({ seed: layerId, luminosity: "light" }),
                weight: 2,
                fillOpacity: 0.4,
            },

            pointToLayer: (feature, latlng) => {
                if (!pointRenderer) return L.marker(latlng, { pane });

                const cfg = pointRenderer(feature);

                if (!cfg || cfg.type === "hidden") {
                    return L.circleMarker(latlng, {
                        radius: 0,
                        opacity: 0,
                        fillOpacity: 0,
                        interactive: false,
                        pane,
                    });
                }

                if (cfg.type === "label") {
                    return L.marker(latlng, {
                        pane,
                        interactive: cfg.interactive ?? false,
                        icon: L.divIcon({
                            className: cfg.className ?? "map-label",
                            html: cfg.text ?? "",
                        }),
                    });
                }

                return L.marker(latlng, { pane });
            },

            onEachFeature: (feature, lyr) => {
                feature.properties = { ...(feature.properties || {}) };
                feature.properties.id = feature.properties.id ?? layerId;

                const popup = popupContent || item?.popupContent || item?.popup || null;
                if (!popup) return;

                const api = {
                    close: () => lyr.closePopup(),
                    open: () => lyr.openPopup(),
                    layer: lyr,
                    feature,
                    item,
                };

                const content =
                    typeof popup === "function" ? popup(feature, item, api) : popup;

                const container = renderPopupContainer(content, {
                    feature,
                    item,
                    layer: lyr,
                });
                lyr.bindPopup(container);
                popupToOpen = lyr;
            },
        });

        if (autoOpenPopup && popupToOpen) {
            requestAnimationFrame(() => popupToOpen.openPopup());
        }

        return { layer, popupToOpen };
    }
    catch (e) {
        console.error(
            "ERROR EN createGeoJsonLayer",
            e,
            e?.stack,
        );
        return {
            layer: null,
            popupToOpen: null,
        };
    }

}
